import React, { useState } from "react";
import "./PerformanceBonus.css";
import { FaCheck, FaArrowUpRightFromSquare, FaUser } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
const totalUsers = 12;
const completedUsers = 5;

const users = Array.from({ length: totalUsers }, (_, index) => ({
  id: index + 1,
  completed: index < completedUsers,
}));

const PerformanceBonus = () => {
  const [status, setStatus] = useState("Complete");
  return (
    <section className="container px-lg-5 pt-4">
      <div className="bonus-card  ">
        <div className="bonus-header">
          <div className="bonus-left">
            <div>
              <h2>Performance Bonus</h2>
              <p>
                Description : Claim for performance bonus by adding 12 users
                under 1 year of time
              </p>
            </div>
          </div>
          <button
            className={`claim-btn ${
              status === "Complete" ? "completed" : "pending"
            }`}
          >
            {status}
          </button>
        </div>

        <div className="bonus-info">
          <span>Users added</span>
          <strong>
            {completedUsers}/{totalUsers}
          </strong>
        </div>

        <Swiper
          spaceBetween={14}
          slidesPerView={"auto"}
          freeMode={true}
          grabCursor={true}
          mousewheel={true}
        >
          {users.map((user) => (
            <SwiperSlide key={user.id} style={{ width: "52px" }}>
              <div
                className={`user-circle ${user.completed ? "completed" : ""}`}
              >
                {user.completed ? <FaCheck /> : user.id}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="progress">
          <div
            className="progress-fill"
            style={{
              width: `${(completedUsers / totalUsers) * 100}%`,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default PerformanceBonus;
